import { Select } from "antd";
import { useNotaSituacaoListar } from "../../../../../../Services/Financeiro/Titulo/Nota/NotaSituacaoService";
import { SelectComPesquisa } from "../../../../../SelectComPesquisa";

interface INotaSituacaoSelectProps extends Omit<React.ComponentProps<typeof Select>, | "showSearch" | "optionFilterProp" | "filterOption"> {
}
export default function NotaSituacaoSelect({
    ...props
}:INotaSituacaoSelectProps) {   
    const {
        data,
        isLoading
    } = useNotaSituacaoListar({
        ativo : true
    });

    return <SelectComPesquisa
        {...props}
        placeholder={"Selecione"}
        allowClear
        loading={isLoading}
        options={data?.map(m => {
            return {
                value : m.codigo,
                label : m.nome
            }
        })}
    />
}